import { HomePage } from "@components/pages/HomePage"
import { SiteShell } from "@components/SiteShell"
import { createFileRoute } from "@tanstack/react-router"
import { localizedRouteHead } from "@utils/routeHead"
import { pageLabels } from "@utils/routeLabels"

export const Route = createFileRoute("/$locale/")({
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "index", path: `/${locale}` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: routeLocale } = Route.useParams()
  const locale = routeLocale as "en" | "ja"
  const labels = pageLabels(locale, "index")
  return (
    <SiteShell
      locale={locale}
      page={labels.page}
    >
      <HomePage locale={locale} />
    </SiteShell>
  )
}
